export const AJOUTE_URL_SOCIETE = "AJOUTE_URL_SOCIETE";
export const SUPRIMER_URL_SOCIETE = "SUPRIMER_URL_SOCIETE";